import { GET_CARD_FAB_SURGE, GET_CARD_FAB_SURGE_SUCCESS, GET_CARD_FAB_SURGE_ERROR, GET_CARD_FAB_SURGE_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCardFabSurge = (state = initialState, action) => {
  switch (action.type) {
    case GET_CARD_FAB_SURGE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CARD_FAB_SURGE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_CARD_FAB_SURGE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CARD_FAB_SURGE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCardFabSurge;
